import { createRouter, createWebHistory } from 'vue-router'
import HomePage from './views/HomePage.vue'
import { applyRouteSeo } from './utils/seo'
// Page titles, descriptions, and location data live in seo/pages.json so the
// build step (scripts/route-heads.js) can write them into each page's HTML too.
import seoPages from './seo/pages.json'

const AboutPage = () => import('./views/AboutUsPage.vue')
const chat = () => import('./components/QuickChat.vue')
const RoofingPage = () => import('./views/PhotoGallery/RoofingPage.vue')
const RepairsPage = () => import('./views/PhotoGallery/RepairsPage.vue')
const SidingPage = () => import('./views/PhotoGallery/SidingPage.vue')
const GutterPage = () => import('./views/PhotoGallery/GutterPage.vue')
const FasciaSoffitPage = () => import('./views/FasciaSoffitPage.vue')
const GaylordPage = () => import('./views/Locations/GaylordPage.vue')
const StormDamagePage = () => import('./views/StormDamagePage.vue')
const RoofReplacementPage = () => import('./views/RoofReplacementPage.vue')
const RoofRepairPage = () => import('./views/RoofRepairPage.vue')
const NotFoundPage = () => import('./views/NotFoundPage.vue')

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage,
    meta: {
      breadcrumb: 'Home',
      seo: seoPages['/']
    }
  },
  {
    path: '/about',
    name: 'About',
    component: AboutPage,
    meta: {
      breadcrumb: 'About',
      seo: seoPages['/about']
    }
  },
  {
    path: '/roofing-projects',
    name: 'RoofingProjects',
    component: RoofingPage,
    meta: {
      breadcrumb: 'Roofing Projects',
      seo: seoPages['/roofing-projects']
    }
  },
  {
    path: '/repair-projects',
    name: 'RepairProjects',
    component: RepairsPage,
    meta: {
      breadcrumb: 'Roof Repair',
      seo: seoPages['/repair-projects']
    }
  },
  {
    path: '/gaylord-roof-repair',
    alias: ['/gaylord-roofing', '/gaylord'],
    name: 'GaylordRoofRepair',
    component: GaylordPage,
    meta: {
      breadcrumb: 'Gaylord Roof Repair',
      seo: seoPages['/gaylord-roof-repair']
    }
  },
  {
    path: '/roof-replacement',
    name: 'RoofReplacement',
    component: RoofReplacementPage,
    meta: {
      breadcrumb: 'Roof Replacement',
      seo: seoPages['/roof-replacement']
    }
  },
  {
    path: '/roof-repair',
    name: 'RoofRepair',
    component: RoofRepairPage,
    meta: {
      breadcrumb: 'Roof Repair',
      seo: seoPages['/roof-repair']
    }
  },
  {
    path: '/storm-damage-repair',
    name: 'StormDamage',
    component: StormDamagePage,
    meta: {
      breadcrumb: 'Storm Damage Repair',
      seo: seoPages['/storm-damage-repair']
    }
  },
  {
    path: '/siding-services',
    name: 'SidingServices',
    component: SidingPage,
    meta: {
      breadcrumb: 'Siding Services',
      seo: seoPages['/siding-services']
    }
  },
  {
    path: '/fascia-soffit',
    name: 'FasciaSoffit',
    component: FasciaSoffitPage,
    meta: {
      breadcrumb: 'Fascia & Soffit',
      seo: seoPages['/fascia-soffit']
    }
  },
  {
    path: '/gutter-services',
    name: 'GutterServices',
    component: GutterPage,
    meta: {
      breadcrumb: 'Gutter Services',
      seo: seoPages['/gutter-services']
    }
  },
  {
    path: '/chat',
    name: 'Chat',
    component: chat,
    meta: {
      seo: seoPages['/chat']
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFoundPage,
    meta: {
      seo: seoPages['notFound']
    }
  }

]

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
      return { top: 0 }
    }
  })

router.afterEach((to) => {
  applyRouteSeo(to)
})


export default router